import { Menu } from "antd";
import { clsx } from "clsx";
import { useSelector } from "react-redux";
import { useLocation, Link } from "react-router-dom";

import { AppPagePaths } from "App/routes/paths";
import SideNavContainer from "Components/shared/SidenavItems/SideNavContainer";
import { AgentDesktopSubPages } from "Services/state/agent/desktopUI/AgentDesktopUISlice";
import { selectTasksLength } from "Services/state/tasks/Selectors";
import { CollapsiblePanel } from "Utils/CollapsiblePanels";
import { useKnownPanels } from "Utils/CollapsiblePanels/knownPanels";

import { ContactListSavedViews } from "./ContactListSavedViews";

import styles from "./AgentDesktopSideNav.module.scss";

export function AgentDesktopSideNav(): JSX.Element {
    const { pathname } = useLocation();
    const numTasks = useSelector(selectTasksLength);
    const { adSubNav } = useKnownPanels();

    return (
        <CollapsiblePanel panelName={adSubNav.name} expandedWidth={adSubNav.width}>
            <div className={clsx(styles.container)}>
                {/* Todo: figue out how this is different from RVSideNavLayout and how we can unify them */}
                <SideNavContainer sidenavTitle="Agent Desktop" trigger={null} data-testid="agent-desktop-sidenav">
                    <div className={clsx(styles.menuWrap, styles.taskMenuItem)}>
                        <Menu.Item
                            className={clsx(styles.menuItem, {
                                [styles.selected]: pathname === AppPagePaths.agentDesktop,
                            })}
                        >
                            <Link to={AppPagePaths.agentDesktop}>Current Tasks</Link>
                        </Menu.Item>
                        <div className={styles.countSpacer}>
                            <p data-testid="task-count" className={styles.taskCount}>
                                {numTasks ? numTasks : ""}
                            </p>
                        </div>
                    </div>

                    <div className={styles.menuWrap}>
                        <Menu.Item
                            className={clsx(styles.menuItem, {
                                [styles.selected]:
                                    pathname === `${AppPagePaths.agentDesktop}/${AgentDesktopSubPages.CONTACT_PAGE}`,
                            })}
                        >
                            <Link to={`${AppPagePaths.agentDesktop}/${AgentDesktopSubPages.CONTACT_PAGE}`}>
                                My Contacts
                            </Link>
                        </Menu.Item>
                    </div>

                    <ContactListSavedViews pathname={pathname} />
                </SideNavContainer>
            </div>
        </CollapsiblePanel>
    );
}
